"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.number.constructor");
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _validate = require("../../utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    pol: {
      type: String,
      default: null
    },
    singleContainerFlag: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      fileList: [],
      checkPriceVisible: false,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'checkPriceQuery'])),
  created: function created() {},
  mounted: function mounted() {
    console.log(this.checkPriceQuery, '2288888888222');
  },
  methods: {
    validateNull: _validate.validateNull,
    handleClose: function handleClose() {
      this.checkPriceVisible = false;
    },
    handleSubmit: function handleSubmit() {
      var chargeDetails = (0, _validate.validateNull)(this.checkPriceQuery.chargeDetails) ? 'NoCharge' : this.checkPriceQuery.chargeDetails;
      this.$emit('handleCheckPriceSubmit', chargeDetails);
    },
    opened: function opened() {}
  }
};